import { createStore } from 'vuex';
import VuexPersistence from 'vuex-persist';

const vuexLocal = new VuexPersistence({
    storage: window.localStorage
});

export default createStore({
    state: {
        isAuthenticated: false,
        accessToken: null,
        accessLevel: null,
        // Optional date used to focus the calendar (format: YYYY-MM-DD)
        calendarTargetDate: null,
        // Optional headquarters id used to focus the calendar's HQ filter
        calendarTargetHq: null,
        showSessionExpiredMessage: false
    },
    mutations: {
        MakeAuth(state, { token, level }) {
            state.accessToken = token;
            state.accessLevel = level;
            state.isAuthenticated = true;
        },
        ClearAuth(state) {
            state.accessToken = null;
            state.accessLevel = null;
            state.isAuthenticated = false;
        },
        setShowSessionExpired(state, { showMessage }) {
            state.showSessionExpiredMessage = (showMessage == true);
        },
        SetCalendarTargetDate(state, { date }){
            state.calendarTargetDate = date;
        },
        SetCalendarTargetHq(state, { hqId }){
            state.calendarTargetHq = hqId;
        }
    },
    actions: {
        async makeLogin({ commit }, credentials) {
            commit('MakeAuth', {
                token: 'Bearer ' + credentials.accessToken,
                level: credentials.accessLevel
            });
        },
        async makeLogout({ commit }) {
            commit('ClearAuth');
        },
        async setSessionExpiredMessage({ commit }, data ) {
            const showMessage = data.showMessage;
            commit('setShowSessionExpired', { showMessage });
        },
        async setCalendarTargetDate({ commit }, { date }){
            commit('SetCalendarTargetDate', { date });
        },
        async setCalendarTargetHq({ commit }, { hqId }){
            commit('SetCalendarTargetHq', { hqId });
        }
    },
    modules: {
    },
    getters: {
        accessToken: (state) => state.accessToken,
        sessionExpiredMessage: (state) => state.showSessionExpiredMessage,
        calendarTargetDate: (state) => state.calendarTargetDate,
        calendarTargetHq: (state) => state.calendarTargetHq,
    },
    plugins: [vuexLocal.plugin]
})
